// When changing APP_ROOT don't forget change it in webpack cfg.
export const CONTEXT = 'onboarding'
export const APP_ROOT = process.env.NODE_ENV === 'development' ? '/' : `/${CONTEXT}/`
export const API_ROOT = process.env.APP_API_URL
  ? `https:${process.env.APP_API_URL}/${CONTEXT}/api/`
  : `/${CONTEXT}/api/`
export const WS_API_ROOT = process.env.APP_API_URL
  ? `wss:${process.env.APP_API_URL}/${CONTEXT}/api/`
  : `wss://${window.location.hostname}/${CONTEXT}/api/`
export const CREATE_ACCOUNT = `${APP_ROOT}create-account`
export const CREATE_INVESTOR_ACCOUNT = `${APP_ROOT}create-investor-account`
export const CONFIRM_EMAIL_PATH = `${APP_ROOT}confirm-email`
export const UPGRADE_TIER_PATH = `${APP_ROOT}upgrade-tier`
export const CREATE_MASTER_ACCOUNT = `${APP_ROOT}create-master-account`
export const CREATE_PAMM_FUND = `${APP_ROOT}create-pamm-fund`
// API routes
export const WS_NOTIFICATIONS = `${WS_API_ROOT}socket/notification`
export const INITIAL_REGISTRATION = `${API_ROOT}public/initial-registration`
export const RENEW_REGISTRATION = `${API_ROOT}user/renew-registration`
export const CONFIRM_EMAIL_API_PATH = `${API_ROOT}public/confirm-email`
export const UPGRADE_TIER_API_PATH = `${API_ROOT}public/upgrade-tier`
export const COUNTRIES_API_PATH = `${API_ROOT}public/countries`
export const COB_COUNTRIES_API_PATH = `${API_ROOT}public/cob-countries`
export const CITIZENSHIP_COUNTRIES_API_PATH = `${API_ROOT}public/citizenship-countries`
export const CURRENCIES_API_PATH = `${API_ROOT}public/deposit-currencies`
export const PAMM_DEPOSIT_CURRENCIES_API_PATH = `${API_ROOT}public/pamm-deposit-currencies`
export const RESEND_TOKEN_API_PATH = `${API_ROOT}public/resend-confirmation`
export const WHITELABEL_CONFIG_API_PATH = `${API_ROOT}public/whitelabel-config`
export const VERSION_API_PATH = `${API_ROOT}public/version`
export const MOBILE_VERIFICATION_SEND_CODE = `${API_ROOT}public/mobile/verification-start`
export const MOBILE_VERIFICATION_CONFIRM = `${API_ROOT}public/mobile/verification-complete`
export const VIEW_EXCHANGE_PATH = `${API_ROOT}public/view-demo`
export const ECN_ACK_API_PATH = `${API_ROOT}public/ecn-doc`
export const QUESTIONNAIRE_API_PATH = `${API_ROOT}public/questionnaire`
export const CHECK_LOGIN = `${API_ROOT}public/check-login`
export const PRICING_TIERS_API_PATH = `${API_ROOT}public/client-tiers`
export const PAMM_PRICING_TIERS_API_PATH = `${API_ROOT}public/pamm-client-tiers`
export const PERSON_TITLES_API_PATH = `${API_ROOT}public/person-titles`
export const ACCOUNT_OPEN_REASONS_API_PATH = `${API_ROOT}public/account-open-reasons`
export const EDUCATION_LEVELS_API_PATH = `${API_ROOT}public/education-levels`
export const TRANSACTION_FREQUENCIES_API_PATH = `${API_ROOT}public/transaction-frequencies`
export const PAMM_FUND_API_PATH = `${API_ROOT}public/pamm-fund`
export const PAMM_REGISTRATION_CHECK = `${API_ROOT}public/request-pamm-registration-letter`
export const GET_DEPARTMENT_CONTACTS = `${API_ROOT}public/department-info`
export const DEPOSIT_AMMOUNTS_API_PATH = `${API_ROOT}public/deposit-amounts`
export const PORTFOLIO_EUR_VALUES_API_PATH = `${API_ROOT}public/portfolio-eur-values`
export const EMPLOYMENT_API_PATH = `${API_ROOT}public/employment-situations`
export const BUSINESS_TYPES_API_PATH = `${API_ROOT}public/business-types`
export const BUSINESS_POSITIONS_API_PATH = `${API_ROOT}public/business-positions`
export const ANNUAL_INCOMES_API_PATH = `${API_ROOT}public/annual-incomes`
export const NETWORTH_INCOMES_API_PATH = `${API_ROOT}public/networth-incomes`
export const FUNDS_API_PATH = `${API_ROOT}public/funds-source`
export const QUESTIONNAIRE_CHECK = `${API_ROOT}public/questionnaire/check`
export const DISTR_TYPES_API_PATH = `${API_ROOT}public/distribution-types`
export const WEALTH_SOURCE_API_PATH = `${API_ROOT}public/wealth-source`
export const PROCESS_PROMOTIONAL_API_PATH = `${API_ROOT}public/process-promotional`
export const COMMISSION_TYPES_API_PATH = `${API_ROOT}public/commission-types`
export const COMMISSION_UNITS_API_PATH = `${API_ROOT}public/commission-units`
export const PEP_STATUSES_API_PATH = `${API_ROOT}public/pep-statuses`

export const GET_USER_DETAILS = `${API_ROOT}user/details`
export const GET_USER_UPLOADED_DOCS = `${API_ROOT}user/uploaded-document-ids`
export const GET_USER_UPLOADED_DOC_BY_ID = `${API_ROOT}user/uploaded-document`
export const VERIFY_API_PATH = `${API_ROOT}user/verify-id`
export const ADD_ACCOUNT_DATA = `${API_ROOT}user/add-account-data`
export const REQUEST_TIER_THREE_API_PATH = `${API_ROOT}user/request-tier-three`
export const UPLOAD_EXT_DOC_API_PATH = `${API_ROOT}user/upload-document`
export const TRY_REGISTER_LATER = `${API_ROOT}public/proceed-later`
export const TRY_REGISTER_LATER_USER = `${API_ROOT}user/proceed-later`
export const CREATE_PAMM_FUND_API_PATH = `${API_ROOT}user/create-pamm-fund`
export const REMOVE_EXT_DOC_API_PATH = `${API_ROOT}user/rm-uploaded-document`
export const PLATFORMS_API_PATH = `${API_ROOT}public/mt-platforms`
export const HEDGE_TRADING_API_PATH = `${API_ROOT}public/trading-mode-support`

export const MANIFEST_API_PATH = `${API_ROOT}public/manifest`
